import { render } from "./SliderItem.vue?vue&type=template&id=6e910006&scoped=true"
import script from "./SliderItem.vue?vue&type=script&lang=js"
export * from "./SliderItem.vue?vue&type=script&lang=js"

import "./SliderItem.vue?vue&type=style&index=0&id=6e910006&lang=css"
import "./SliderItem.vue?vue&type=style&index=1&id=6e910006&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e910006"]])

export default __exports__